import { PureComponent, ReactNode, CSSProperties } from 'react'
import * as cn from 'classnames'
import { IS_IE } from 'helpers/userAgentHelpers'
import { MaxMediaSize } from 'helpers/markdownHelpers'

import * as insightStyles from 'components/features/insights/Insight/Insight.css'
import * as styles from 'components/features/insights/Insight/Media.css'

const DEFAULT_IE_INSIGHT_MEDIA_HEIGHT = 250

type InsightMediaBaseProps = {
  maxMediaSize: MaxMediaSize | null
  src: string | null
}


type InsightImageProps = InsightMediaBaseProps & {
  alt: string
  onError: () => void
}

const InsightImage = ({ maxMediaSize, src, alt, onError }: InsightImageProps) => {
  if (!src) {
    return null
  }

  const style: CSSProperties = { ...maxMediaSize }
  const className = cn(styles.image, insightStyles.mediaImage)
  const props = { src, alt, onError, className, style }

  return (
    <img { ...props } />
  )
}

type InsightMediaProps = InsightMediaBaseProps & {
  key: string
  hasGradient?: boolean
  children?: ReactNode
}

export class InsightMedia extends PureComponent<InsightMediaProps> {
  static Image = InsightImage

  render () {
    const { maxMediaSize, hasGradient = false, children, src } = this.props
    const style: CSSProperties = {}
    const isFixRequired = IS_IE && !maxMediaSize
    let placeholderChild: ReactNode = children

    if (maxMediaSize) {
      const { maxWidth, maxHeight } = maxMediaSize
      const aspectRatio = maxHeight / maxWidth
      const placeholderStyle: CSSProperties = { paddingTop: `${ aspectRatio * 100 }%` }
      const placeholderClassName = cn(styles.placeholder, insightStyles.mediaPlaceholder, { hasGradient })

      style.maxWidth = maxWidth
      placeholderChild = (
        <div className={ placeholderClassName } style={ placeholderStyle }>
          { children }
        </div>
      )
    } else if (isFixRequired) {
      style.height = DEFAULT_IE_INSIGHT_MEDIA_HEIGHT
      style.backgroundImage = `url('${ src }')`
    }

    const className = cn(styles.media, {
      [styles.ieFix]: isFixRequired,
    })

    return (
      <div className={ className } style={ style }>
        { placeholderChild }
      </div>
    )
  }
}
